<mat-toolbar class="app-title">Cadastrar Filme</mat-toolbar>
<div class="main-div">
  <mat-card class="center width50" *ngIf="cadastro">
    <form autocomplete="off" novalidate [formGroup]="cadastro" (ngSubmit)="submit()" (ngReset)="reiniciarForm()" (ngVoltar)="voltar()">
      <mat-card-content>
        <dio-input-text titulo="Título *" controlName="titulo" [formGroup]="cadastro"></dio-input-text>
        <dio-input-text titulo="Link Foto" controlName="urlFoto" [formGroup]="cadastro"></dio-input-text>
        <dio-input-date titulo="Data de Lançamento *" controlName="dtLancamento" [formGroup]="cadastro"></dio-input-date>
        <dio-input-textarea titulo="Descrição" controlName="descricao" [formGroup]="cadastro"></dio-input-textarea>
        <dio-input-number titulo="Nota IMDb *" controlName="nota" step="0.1" [formGroup]="cadastro"></dio-input-number>
        <dio-input-text titulo="Link IMDb" controlName="urlIMDb" [formGroup]="cadastro"></dio-input-text>
        <dio-input-select titulo="Gênero *" [opcoes]="generos" controlName="genero" [formGroup]="cadastro"></dio-input-select>
      </mat-card-content>
      <div class="opcoes">
        <mat-card-actions>
          <button type="submit" color="accent" mat-raised-button>Salvar</button>
          <button type="reset" color="warn" mat-raised-button>Cancelar</button>
          <button (click)="voltar()" color="primary" mat-raised-button>Voltar</button>
        </mat-card-actions>
      </div>
    </form>
  </mat-card>
</div>
